exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-7843241a]{margin:0}.add-height[data-v-7843241a]{height:200px}\n", ""]);

// exports
